import { render, staticRenderFns } from "./expand-column.vue?vue&type=template&id=17f4b43a"
import script from "./expand-column.vue?vue&type=script&lang=js"
export * from "./expand-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f4b43a')) {
      api.createRecord('17f4b43a', component.options)
    } else {
      api.reload('17f4b43a', component.options)
    }
    module.hot.accept("./expand-column.vue?vue&type=template&id=17f4b43a", function () {
      api.rerender('17f4b43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/setting/expand-column.vue"
export default component.exports